import { useRef, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "components/Header";
import Footer from "components/Footer";
import SplashScreen from "components/SplashScreen";
import Home from "pages/Home";
import Store from "pages/Store";
import Videos from "pages/Videos";
import Blog from "pages/Blog";
import Birds from "pages/Birds";
import Contact from "pages/Contact";

function App() {
  const [isReady, setIsReady] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <Router>
      <div className="App">
        {/* Mounted from the very first render (hidden) so the splash can scan
            the real page's <img> tags and wait for them, instead of guessing. */}
        <div
          ref={contentRef}
          aria-hidden={!isReady}
          className={isReady ? "" : "invisible fixed inset-0 overflow-hidden"}
        >
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/store" element={<Store />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/birds" element={<Birds />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </div>

        {!isReady && (
          <SplashScreen contentRef={contentRef} onReady={() => setIsReady(true)} />
        )}
      </div>
    </Router>
  );
}

export default App;
